<label [for]="id" class="fc-editor-label" *ngIf="!!textValue">
    {{ editorLabel }}
</label>
<div [id]="id"
     class="fc-editor">
    <div #editorWrapper class="fc-editor-wrapper">
        <fc-ag-editor-menu [editor]="editor" [toolbar]="toolbar"> </fc-ag-editor-menu>
        <div class="FcAgEditor" #fcAgEditor>
            <ng-content></ng-content>
        </div>
    </div>
</div>


